const INITIAL_STATE = {
  alerta: {},
  esperandoSolicitacao: false
};

const MESSAGE_INIT = 'Revise seu pedido e se necessário alteração, clique em Voltar e realize os ajustes necessários.'
export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_CONCLUIR_INICIAR':
      return { ...state, esperandoSolicitacao: false, alerta: { message: MESSAGE_INIT, severity: 'warning' } }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_INICIAR':
      return { ...state, esperandoSolicitacao: false, alertaFinalizar: { message: action.payload, severity: 'success' } }
    case 'REQUERIMENTO_CONCLUIR_CLOSE_MESSAGE':
      return { ...state, alerta: {} } 
    case 'REQUERIMENTO_CONCLUIR_INICIAR_SALVAR':
      return { ...state, esperandoSolicitacao: true }
    case 'REQUERIMENTO_CONCLUIR_FIM_SALVAR':
      return { ...state, esperandoSolicitacao: false }  
    case 'REQUERIMENTO_CONCLUIR_SET_ALERT': 
      return { ...state, alerta: action.payload }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE':
      return { ...state, esperandoSolicitacao: true }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE_SUCESSO':
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_CONCLUIR_FINALIZAR_COMPROVANTE_ERRO':
      return { ...state, esperandoSolicitacao: false }  
    default:
      return state;
  }
}
